import cx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as TypeDocIcon } from '@assets/svg/file-types/ic-type_doc.svg';
import { ReactComponent as TypeExcelIcon } from '@assets/svg/file-types/ic-type_exl.svg';
import { ReactComponent as TypeHeicIcon } from '@assets/svg/file-types/ic-type_heic.svg';
import { ReactComponent as TypeAudioIcon } from '@assets/svg/file-types/ic-type_mp3.svg';
import { ReactComponent as TypeVideoIcon } from '@assets/svg/file-types/ic-type_mpg4.svg';
import { ReactComponent as TypePDFIcon } from '@assets/svg/file-types/ic-type_pdf.svg';

import FileImagePreview from './FileImagePreview';
import style from './style.module.scss';

const TYPE_ICONS_LIST = {
  video: TypeVideoIcon,
  audio: TypeAudioIcon,
  csv: TypeExcelIcon,
  pdf: TypePDFIcon,
  msword: TypeDocIcon,
  text: TypeDocIcon,
  image: FileImagePreview,
  heic: TypeHeicIcon,
  'vnd.openxmlformats-officedocument.wordprocessingml.document': TypeDocIcon,
  'vnd.oasis.opendocument.text': TypeDocIcon,
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': TypeExcelIcon,
  'vnd.ms-excel': TypeExcelIcon,
  'vnd.ms-powerpoint': TypeDocIcon,
  'vnd.openxmlformats-officedocument.presentationml.presentation': TypeDocIcon,
  'vnd.ms-outlook': TypeDocIcon,
};

const FileTypeIcon = ({ file, variant }) => {
  const { name, type, extension, preview } = file;

  const getTypeKey = () => {
    const [mainType, secondaryType] = (type || extension || '').split('/');

    if (mainType === 'application' || secondaryType === 'heic') {
      return secondaryType;
    } else {
      return mainType;
    }
  };

  const CurrentIcon = TYPE_ICONS_LIST[getTypeKey()] || null;

  return (
    <div className={cx(style.previewIcon, { [style.previewIconSecondary]: variant === 'secondary' })}>
      {CurrentIcon && <CurrentIcon className={style.iconSvg} preview={preview} title={name} />}
    </div>
  );
};

FileTypeIcon.propTypes = {
  file: PropTypes.object,
};

export default FileTypeIcon;
